export const SET_VIEW_CONTEXT = "SELECTION_SET_VIEW_CONTEXT";
export const CLEAR_VIEW_CONTEXT = "SELECTION_CLEAR_VIEW_CONTEXT";
export const ACKNOWLEDGE_ERROR = "ACKNOWLEDGE_ERROR";
export const SHOW_DATE_PICKER = "SHOW_DATE_PICKER";
export const CLOSE_DATE_PICKER = "CLOSE_DATE_PICKER";
export const SHOW_CONTEXTUAL_MENU = "SHOW_CONTEXTUAL_MENU";
export const CLOSE_CONTEXTUAL_MENU = "CLOSE_CONTEXTUAL_MENU";

export function setViewContext(context, title) {
  return {
    type: SET_VIEW_CONTEXT,
    context, title
  }
}

export function clearViewContext(context) {
  return {
    type: CLEAR_VIEW_CONTEXT,
    context
  }
}

export function acknowledgeError() {
  return {
    type: ACKNOWLEDGE_ERROR
  }
}

export function showDatePicker(field, date, options = {}) {
  return {
    type: SHOW_DATE_PICKER,
    field, date, options
  }
}

export function closeDatePicker() {
  return {
    type: CLOSE_DATE_PICKER
  }
}

export function showContextualMenu(items, x, y) {
  return {
    type: SHOW_CONTEXTUAL_MENU,
    items, x, y
  }
}

export function closeContextualMenu() {
  return {
    type: CLOSE_CONTEXTUAL_MENU
  }
}